// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import globalData from './common/globalData'
import globalFunc from './common/globalFunc'
import globalFuncWS from './common/globalFuncWS'
import './style/global.css'
import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'
import './assets/fonts/font.css'

Vue.prototype.GLOBAL = globalData

Vue.config.productionTip = false

Vue.use(ElementUI)
Vue.use(globalFunc)
Vue.use(globalFuncWS)

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  components: { App },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js